import React from "react";
import {Col, Container, Row} from "react-bootstrap";
import ucarSolutionsLogoSolo from '../assets/img/Ucar-Solutions-Logo-Solo.png';
import './Footer.css';
import {useTranslation} from "react-i18next";

const Footer = () => {
    const {t} = useTranslation();
    return (
        <footer
            className={"bg-secondary text-white p-5"}
        >
            <Container>
                <Row className={"d-flex justify-content-between"}>
                    <Col md={4} className="text-center mb-3">
                        <p className={"font-size-14px"}>
                            {t("pages.home.footer.vendorText")}
                            <a className={"text-white"}
                               target={"_blank"}
                               rel={"noreferrer"}
                               href="https://ucar-solutions.de"> Ucar Solutions UG
                                (haftungsbeschränkt)</a>
                        </p>
                        <img src={ucarSolutionsLogoSolo} alt="Ucar Solutions Logo"
                             className={"img-fluid rounded w-25"}/>
                    </Col>

                    <Col md={4} className="text-center mb-3">
                        <p className={"font-size-14px"}>Email: info [at] ucar-solutions.de</p>
                        <p className={"font-size-14px"}>Phone: +49 6192 98 99 814</p>
                    </Col>
                </Row>
                <Row className="text-center mt-3">
                    <Col>
                        <p className={"font-size-14px"}>
                            © 2025 <a className={"text-white"}
                                      target={"_blank"}
                                      rel={"noreferrer"}
                                      href="https://ucar-solutions.de"> Ucar Solutions UG
                            (haftungsbeschränkt)</a>. All Rights Reserved.
                        </p>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
};

export default Footer;
